import { BASE_URL } from '@/shared/lib/const/env'
import { AggregateOfferSchema, AggregateOfferSchemaProps } from '@/shared/lib/seo'
import { TProduct } from '@/shared/types/product-types'

type AggregateOfferSchemaScriptProps = {
	products: TProduct[]
	totalProducts: number
	categoryTitle: string
	categoryImg: string
}

export const AggregateOfferSchemaScript = (props: AggregateOfferSchemaScriptProps) => {
	const { products, totalProducts, categoryTitle, categoryImg } = props

	const allProductsPrice = products?.map(product => product.PRICE.VALUE)
	const allProductsLinks = products?.map(product => `/products/productID${product.KOD}`)

	const aggregateOfferSchemaInfo: AggregateOfferSchemaProps = {
		name: categoryTitle,
		image: `${BASE_URL}${categoryImg}`,
		highPrice: Math.max(...allProductsPrice),
		lowPrice: Math.min(...allProductsPrice),
		offerCount: totalProducts,
		offers: allProductsLinks,
		ratingValue: 5,
		ratingCount: 16,
		reviewCount: 2
	}

	return (
		<script
			type="application/ld+json"
			data-label="AggregateOfferSchema"
			dangerouslySetInnerHTML={{
				__html: JSON.stringify(AggregateOfferSchema(aggregateOfferSchemaInfo))
			}}
		/>
	)
}
